var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBadgeSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 220,
    viewBox: "0 0 180 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.625 120C35.625 73.401 73.401 35.625 120 35.625C166.599 35.625 204.375 73.401 204.375 120C204.375 166.599 166.599 204.375 120 204.375C73.401 204.375 35.625 166.599 35.625 120ZM120 24.375C67.1878 24.375 24.375 67.1878 24.375 120C24.375 172.812 67.1878 215.625 120 215.625C172.812 215.625 215.625 172.812 215.625 120C215.625 67.1878 172.812 24.375 120 24.375ZM154.577 100.769C156.383 98.2415 155.797 94.7284 153.269 92.9228C150.742 91.1171 147.228 91.7026 145.423 94.2305L112.297 140.607C112.027 140.984 111.484 141.029 111.156 140.701L93.9775 123.523C91.7808 121.326 88.2192 121.326 86.0225 123.523C83.8258 125.719 83.8258 129.281 86.0225 131.477L108.523 153.977C109.692 155.147 111.316 155.742 112.964 155.606C114.612 155.469 116.116 154.615 117.077 153.269L154.577 100.769Z",
    fill: "#0E7241"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadgeSuccess);
export default __webpack_public_path__ + "static/media/icon-badge-success.3b293493dd44d789a4c7c3e4b9315361.svg";
export { ForwardRef as ReactComponent };